import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleRemoveAlternate.svg",
  "use": "CircleRemoveAlternate.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleRemoveAlternate.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56ZM17,32a2,2,0,0,1,2-2H45a2,2,0,0,1,0,4H19A2,2,0,0,1,17,32Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol